import { ChangeEvent, FC } from 'react';

import { DOT } from 'utils/constants/common';

import multicreationSelectAllButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/auction/multicreation/multicreation_select_all_button_click';
import { Cell, Checkbox, HSpacing, TableCell, TableHeader, TableRow, Text, useBreakpoint } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { MAX_VACANCY_SELECT } from 'components/MultiCreationAuction/VacanciesTable/VacanciesTable';

import { setMultiCreationSelectedVacancyIds } from 'store/models/multiCreation';
import { useDispatch, useSelector } from 'store/utils';

import styles from 'components/MultiCreationAuction/VacanciesTable/VacanciesTableHeader/VacanciesTableHeader.module.less';

const TrlKeys = {
    selectAll: 'MultiCreationAuction.VacanciesTable.VacanciesTableHeader.selectAll',
    areas: 'MultiCreationAuction.VacanciesTable.VacanciesTableHeader.areas',
    users: 'MultiCreationAuction.VacanciesTable.VacanciesTableHeader.users',
};

export const VacanciesTableHeader: FC<{ paddingLeft?: number; paddingRight?: number; isModal?: boolean }> = ({
    paddingLeft = 0,
    paddingRight = 0,
    isModal,
}) => {
    const vacancies = useSelector(({ multiCreation }) => multiCreation.vacancies);
    const selectedVacancyIds = useSelector(({ multiCreation }) => multiCreation.selectedVacancyIds);

    const { isMobile } = useBreakpoint();
    const trls = useTrls();
    const dispatch = useDispatch();

    const selectedVacanciesCount = Object.keys(selectedVacancyIds).length;

    const onSelectAllToggle = (event: ChangeEvent<HTMLInputElement>) => {
        const checked = event.target.checked;

        multicreationSelectAllButtonClick({
            place: 'table',
            checkedVacanciesCount: selectedVacanciesCount,
        });

        if (!checked) {
            dispatch(setMultiCreationSelectedVacancyIds({}));
            return;
        }

        const newSelectedVacanciesIds = { ...selectedVacancyIds };
        vacancies.some(({ vacancyId }) => {
            newSelectedVacanciesIds[vacancyId] = true;
            return Object.keys(newSelectedVacanciesIds).length >= MAX_VACANCY_SELECT;
        });
        dispatch(setMultiCreationSelectedVacancyIds(newSelectedVacanciesIds));
    };

    const firstCell = (
        <Cell
            vertPadding={isMobile}
            left={
                <Checkbox
                    data-qa="check-all-checkbox"
                    checked={selectedVacanciesCount > 0}
                    indeterminate={selectedVacanciesCount > 0 && selectedVacanciesCount < vacancies.length}
                    onChange={onSelectAllToggle}
                />
            }
        >
            <Text style="secondary" typography="label-2-regular">
                {trls(TrlKeys.selectAll)}
                <HSpacing default={4} />
                {DOT}
                <HSpacing default={4} />
                {vacancies.length}
            </Text>
        </Cell>
    );

    return (
        <>
            {isMobile || isModal ? (
                <div className={isModal ? '' : styles.mobileHeader} style={{ paddingLeft, paddingRight }}>
                    {firstCell}
                </div>
            ) : (
                <TableHeader>
                    <TableRow align={'left'}>
                        <TableCell Element="th" m={12}>
                            <div className={styles.rowWrapper}>
                                <div className={styles.nameColumn}>{firstCell}</div>
                                <div className={styles.areaColumn}>
                                    <Text style="secondary" typography="label-2-regular">
                                        {trls(TrlKeys.areas)}
                                    </Text>
                                </div>
                                <div className={styles.managerColumn}>
                                    <Text style="secondary" typography="label-2-regular">
                                        {trls(TrlKeys.users)}
                                    </Text>
                                </div>
                            </div>
                        </TableCell>
                    </TableRow>
                </TableHeader>
            )}
        </>
    );
};
